import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import { getUrlParam } from '@/utils/url';
import { usePower } from '@/hooks';

const { distributionUnitName, id } = getUrlParam();
// const { EMP_FS_TAB } = usePower('/logistics/receptionist');

const model = {
  state: {
    cbdId: null,
    // activeTab: EMP_FS_TAB ? 'FS' : 'Merchant',
    welfareId: 0,
    companyList: [],
    unitList: [],
    queryParams: {
      employeeId: null,
      employee: null,
      employeePhone: null,
      companyId: '',
      type: '',
      status: '',
      healthCertificateStatus: '',
      per_page: 50,
      cur_page: 1,
      employeeCapacity: '-1',
      signStatus: -1,
      onPosition: 0,
      employeeSource: -1,
      hasCrime: null,
      distributionUnitId:
        id && distributionUnitName
          ? { label: distributionUnitName, value: id && Number(id) }
          : undefined,
    },
    takeMealFilter: {
      receiverAddressType: -1,
      companyAddressId: '',
      companyId: '',
    },
    list: [],
    listLoading: false,
    listTotal: 0,
    detailModalVisible: false,
    detailLoading: false,
    detailData: {},
    addEditType: 'add',
    editEmployeeId: null,
    initData: {},
    businessDistrictList: [],
    companyData: [],
    companyDataFetching: false,
    selectedCompany: null,
    addressData: [],
    showAddress: true,
    companyNameList: [],
    accrualTypeList: [],
    riderAccrualTypeList: [],
    leavePositionParams: {
      page: 1,
      pageSize: 10,
    },
    leavePositionData: {},
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { receptionist, basic }, getState }) => ({
    // 更新是否显示地址的标志
    updateShowAddress(newV) {
      receptionist.setState({ showAddress: newV });
    },

    // 获取全部企业
    async getCompanyList() {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/getCompanyList');
      if (data) {
        const companyList = [{ id: '', label: '全部' }];
        data.forEach((d) => {
          companyList.push({
            id: d.company_id,
            label: d.company_name,
          });
        });
        receptionist.setState({ companyList });
      }
    },
    // 获取列表
    async getList() {
      receptionist.setState({ listLoading: true });
      const { queryParams, takeMealFilter } = getState().receptionist;
      const params = { ...queryParams, ...takeMealFilter };
      const { distributionUnitId } = queryParams;
      // 转换分页字段
      params.page = params.cur_page;
      params.pageSize = params.per_page;
      delete params.cur_page;
      delete params.per_page;
      if (params.employeeSource === -1) delete params.employeeSource;
      params.distributionUnitId = distributionUnitId?.value;
      const data = await fetch('/saasmerchant/fsarea/employee/list', {
        params: filterNull({
          ...params,
        }),
        type: 'POST',
        useJson: true,
      });
      receptionist.setState({ listLoading: false });
      if (data) {
        receptionist.setState({ list: data.list || [], listTotal: data.total || 0 });
      }
    },
    // 搜索
    onSearch(queryParams) {
      const { takeMealFilter } = getState().receptionist;
      const newParams = { ...queryParams, ...takeMealFilter };
      receptionist.setState({ queryParams: newParams });
      receptionist.getList();
    },

    setTakeMealFilter(val) {
      const { takeMealFilter } = getState().receptionist;
      receptionist.setState({ takeMealFilter: { ...takeMealFilter, ...val } });
    },
    // 底部换页
    onNav(page) {
      const { queryParams } = getState().receptionist;
      // receptionist.setState({ queryParams: { ...queryParams, cur_page: page } });
      const { takeMealFilter } = getState().receptionist;
      const newParams = { ...queryParams, ...takeMealFilter };
      receptionist.setState({ queryParams: { ...newParams, cur_page: page } });
    },
    // 重置筛选项
    onReset() {
      receptionist.setState({
        queryParams: {
          employeeId: null,
          employee: null,
          employeePhone: null,
          companyId: '',
          type: '',
          status: '',
          per_page: 50,
          cur_page: 1,
          employeeCapacity: '-1',
          distributionUnitId: undefined,
        },
        takeMealFilter: {
          receiverAddressType: -1,
          companyAddressId: '',
          companyId: '',
        },
      });
    },
    // 生效、无效
    async onDisable(employeeId, nowStatus, distributionUnitId) {
      let status = 1; // 有效
      if (nowStatus === 1) {
        status = 2; // 无效
      }
      const data = await fetch('/saasmerchant/fsarea/employee/effect', {
        type: 'POST',
        useJson: true,
        params: { employeeId, status, distributionUnitId },
      });
      if (data) {
        receptionist.getList();
      }
    },
    // 弹窗
    async setDetailModalVisible(visible, employeeId) {
      receptionist.setState({ detailModalVisible: visible });
      if (visible === true) {
        receptionist.setState({ detailLoading: true });
        const data = await fetch('/saasmerchant/fsarea/employee/detail', {
          type: 'GET',
          params: { employeeId },
        });
        receptionist.setState({ detailLoading: false });
        if (data) {
          receptionist.setState({ detailData: data });
        }
      } else {
        receptionist.setState({ detailData: {} });
      }
    },
    // 新建/修改规则
    async setEmployee(params, history) {
      const { addEditType, editEmployeeId } = getState().receptionist;
      if (addEditType === 'edit') {
        params.employeeId = editEmployeeId;
      }
      const data = await fetch('/saasmerchant/fsarea/employee/set', {
        type: 'POST',
        useJson: true,
        params,
      });
      if (data) {
        if (addEditType === 'add') {
          message.success('员工创建成功');
          receptionist.onReset();
        } else {
          message.success('员工信息编辑成功');
        }
        history.push('/logistics/receptionist');
      }
      return data;
    },
    setAddEditType(type) {
      receptionist.setState({ addEditType: type });
    },
    setCbdId(cbdId) {
      receptionist.setState({ cbdId });
    },
    setInitData(data) {
      receptionist.setState({ initData: data });
    },
    setEditEmployeeId(id) {
      receptionist.setState({ editEmployeeId: id });
    },
    // 获取收餐员详情
    async getEmployeeDetail(employeeId) {
      const data = await fetch('/saasmerchant/fsarea/employee/detail', {
        params: { employeeId },
      });
      return data;
    },
    // 服务企业其收餐地址
    async getbusinessDistrictList(params) {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/authority/queryCbdList', {
        params: {
          cbdStatus: 1, // 生效
          ...params,
        },
      });
      if (data) {
        const businessDistrictList = data.map((d) => ({
          id: d.businessDistrictId,
          label: d.businessDistrictName,
        }));
        receptionist.setState({ businessDistrictList });
      }
    },
    /**
     * 配送单元下拉
     * @param {*} params
     */
    async getUnitList(params) {
      if (!params) {
        receptionist.setState({ unitList: [] });
        return [];
      }
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/base/authority/list', {
        params,
      });
      if (data?.list) {
        const unitList = data?.list?.map((item) => {
          const { distributionUnitName, distributionUnitId } = item;
          return {
            label: distributionUnitName,
            value: distributionUnitId,
            key: distributionUnitId,
            ...item,
          };
        });
        receptionist.setState({ unitList });
        return unitList;
      }
    },

    async getCompanyData(businessDistrictId, value, addressType) {
      receptionist.setState({
        companyData: [],
        companyDataFetching: true,
      });
      const data = await fetch(
        '/saasmerchant/fsarea/businessDistrict/searchBusinessDistrictListCompany',
        {
          type: 'POST',
          params: filterNull({
            businessDistrictIdList: businessDistrictId,
            companyName: value,
            addressType,
            status: 1,
          }),
          useJson: true,
        },
      );
      if (data) {
        const companyData = data.companyList
          .filter((d) => d.status !== 0) // 过滤失效
          .map((d) => ({
            label: d.companyName,
            id: d.companyId,
          }));
        const newCompanyData = []; // 去重
        companyData.forEach((company) => {
          if (!newCompanyData.find((newCompany) => newCompany.id === company.id)) {
            newCompanyData.push(company);
          }
        });
        receptionist.setState({ companyData: newCompanyData });
      }
      receptionist.setState({ companyDataFetching: false });
    },
    clearCompanyData() {
      receptionist.setState({ companyData: [] });
    },
    async onSelectCompany(businessDistrictId, company) {
      if (company) {
        const data = await fetch(
          '/saasmerchant/fsarea/businessDistrict/searchBusinessDistrictListCompany',
          {
            type: 'POST',
            useJson: true,
            params: filterNull({
              businessDistrictIdList: businessDistrictId,
              companyId: company.key,
            }),
          },
        );
        if (data) {
          const addressData = [
            {
              title: '全选',
              value: 'all',
              key: 'all',
              children: data.companyList
                .filter((d) => d.status !== 0) // 过滤失效
                .map((d) => ({
                  title: d.address,
                  key: d.companyAddressId,
                  value: d.companyAddressId,
                })),
            },
          ];
          receptionist.setState({ selectedCompany: company.key, addressData });
        }
      } else {
        receptionist.setState({ selectedCompany: null, addressData: [] });
      }
    },
    clearAddressData() {
      receptionist.setState({ addressData: [] });
    },
    // 取餐点筛选项
    async searchCompany(params) {
      const data = await fetch('/saasmerchant/fsarea/company/queryEsInfoByName', {
        params: {
          ...params,
        },
      });
      if (data) {
        receptionist.setState({ companyNameList: data });
      }
      return data;
    },
    cleanCompanyNameList() {
      receptionist.setState({ companyNameList: [] });
    },

    async getAccrualtypeList(workType) {
      const data = await fetch('/saasmerchant/fsarea/accrualtype/querylist', {
        type: 'POST',
        useJson: true,
        params: {
          page: 1,
          pageSize: 10000,
          workType,
        },
      });
      return data;
    },
    // 获取计提类型

    async postAccrualTypeList() {
      Promise.all([receptionist.getAccrualtypeList(1), receptionist.getAccrualtypeList(2)]).then(
        (res) => {
          receptionist.setState({
            accrualTypeList: res[1].list.map((acc) => ({
              id: acc.accrualTypeId,
              label: acc.accrualTypeName,
            })),
            riderAccrualTypeList: res[0].list.map((acc) => ({
              id: acc.accrualTypeId,
              label: acc.accrualTypeName,
            })),
          });
        },
      );
    },
    // 获取离岗日志
    async getLeavePositionLog(params) {
      const { leavePositionParams } = getState().receptionist;
      const queryParams = { ...leavePositionParams, ...params };
      receptionist.setState({ leavePositionParams: queryParams });
      const data = await fetch('/saasmerchant/fsarea/employee/onposition/log', {
        type: 'POST',
        useJson: true,
        params: queryParams,
      });
      if (data) {
        receptionist.setState({ leavePositionData: data });
      }
    },
    // 离岗日志翻页
    onLeavePositionTableNav(page) {
      const { leavePositionParams, cbdId } = getState().receptionist;
      receptionist.setState({ leavePositionParams: { ...leavePositionParams, page, cbdId } });
      receptionist.getLeavePositionLog();
    },
    // 导出员工列表
    async exportEmployeeApi(params) {
      if (params.employeeSource === -1) delete params.employeeSource;
      const data = await fetch('/saasmerchant/fsarea/employee/export', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        message.success('员工列表导出成功');
        basic.setLogListDot(true);
      }
    },
    // 导出员工健康信息列表
    async exportEmployeeHealthApi(params) {
      const data = await fetch('/saasmerchant/fsarea/employee/healthy/export', {
        params,
      });
      if (data) {
        message.success('员工健康信息列表导出成功');
        basic.setLogListDot(true);
      }
      return data;
    },
  }),
};

export default model;
